export class MyReportSearchCriteria {
  searchCriteria?: string;
  status?: string;
  page: number;
  size: number;
}

export class MyReportListResponse {
  page: number;
  size: number;
  totalElements: number;
  first: boolean;
  numberOfElements: number;
  totalPages: number;
  hasContent: boolean;
  last: boolean;
  empty: boolean;
  content: MyReportContent[];
}

export class MyReportContent {
  id: string;
  jobId: string;
  version: number;
  requestNo: string;
  reportName: string;
  type: MyReportTypeEnum;
  requestedDate: string;
  completedDate: string;
  status: string;
}

export class MyReportDownloadCriteria {
  reportNo: string;
  reportType?: MyReportTypeEnum;
}

export enum MyReportTypeEnum {
  SALE_TRANSACTION = 'sales-transactions',
  PRICE_TAG = 'price_tag'
}
